import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: '700px', margin: '0 auto', padding: '2rem 1.5rem', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#333', lineHeight: 1.7 },
  title: { fontSize: '1.75rem', color: '#1a6b3c', marginBottom: '0.25rem' },
  subtitle: { fontSize: '0.9rem', color: '#666', marginBottom: '2rem' },
  h2: { fontSize: '1.15rem', color: '#1a6b3c', marginTop: '1.75rem', marginBottom: '0.5rem' },
  p: { fontSize: '0.9rem', marginBottom: '0.75rem' },
  ul: { paddingLeft: '1.25rem', fontSize: '0.9rem', marginBottom: '0.75rem' },
  highlight: { backgroundColor: '#f0f7f3', border: '1px solid #c8e6c9', borderRadius: '8px', padding: '1rem 1.25rem', marginTop: '1.5rem', fontSize: '0.85rem' },
};

export function PrivacyPolicyPage() {
  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Privacy Policy — SMS Notifications</h1>
      <p style={styles.subtitle}>KDU Georgia 2026 Global Reunion • Last updated: June 8, 2026</p>

      <h2 style={styles.h2}>About This Service</h2>
      <p style={styles.p}>
        KDU Hub ("the Service") is the planning and coordination platform for the KDU Georgia 2026 Global Reunion. 
        As part of event operations, the Service may send SMS text messages to registered members and attendees 
        who have provided a mobile phone number.
      </p>

      <h2 style={styles.h2}>What Information We Collect</h2>
      <p style={styles.p}>When you register or update your profile, you may optionally provide a mobile phone number. This number is used solely for:</p>
      <ul style={styles.ul}>
        <li>Event-related notifications (schedule changes, emergency alerts, assignment reminders)</li>
        <li>Operational messages from event organizers</li>
      </ul>

      <h2 style={styles.h2}>Mobile Number Non-Sharing Policy</h2>
      <p style={styles.p}>
        <strong>We do not sell, share, rent, or disclose your mobile phone number to any third parties for marketing or promotional purposes.</strong> Your 
        number is used exclusively for KDU Georgia 2026 event communications and is stored securely in our database.
      </p>

      <h2 style={styles.h2}>Message Frequency</h2>
      <p style={styles.p}>
        Message frequency varies based on event activity. You may receive up to <strong>5 messages per week</strong> during 
        the active planning period, and up to <strong>10 messages per day</strong> during the reunion event weekend (August 1–3, 2026). 
        Outside of these periods, messages are infrequent (1–2 per month or less).
      </p>

      <h2 style={styles.h2}>Message and Data Rates</h2>
      <p style={styles.p}>
        <strong>Message and data rates may apply.</strong> Your carrier's standard messaging rates apply to all SMS messages 
        sent by this service. Contact your mobile carrier for details about your messaging plan.
      </p>

      <h2 style={styles.h2}>Opting Out</h2>
      <p style={styles.p}>
        You may opt out of SMS notifications at any time by:
      </p>
      <ul style={styles.ul}>
        <li>Replying <strong>STOP</strong> to any message received from this service</li>
        <li>Removing your phone number from your KDU Hub profile (Settings page)</li>
        <li>Contacting an event organizer to request removal</li>
      </ul>
      <p style={styles.p}>
        After opting out, you will no longer receive SMS messages. You will continue to receive in-app notifications 
        through KDU Hub.
      </p>

      <h2 style={styles.h2}>Data Security</h2>
      <p style={styles.p}>
        Phone numbers are stored in an encrypted PostgreSQL database hosted on Railway (US-based infrastructure). 
        Access is restricted to authorized event administrators only.
      </p>

      <h2 style={styles.h2}>Contact</h2>
      <p style={styles.p}>
        For questions about this privacy policy or to request removal of your data, contact the KDU Georgia 2026 
        planning committee at the email address provided during your registration.
      </p>

      <div style={styles.highlight}>
        <strong>Summary of Key Disclosures:</strong><br />
        • We do NOT share your mobile number with third parties<br />
        • Message frequency: up to 5/week (planning), up to 10/day (event weekend)<br />
        • Message and data rates may apply<br />
        • Reply STOP to opt out at any time
      </div>
    </div>
  );
}
